import { useAppStore } from '@/store';
import { getAllAssociatedTokens, useBoomWallet } from '@boomeme/wallet-sdk';
import { useEffect, useState } from 'react';

interface ITokenAmount {
  tokenAddress: string;
  amount: string;
  decimals: number;
  uiAmount: number | string | null;
  uiAmountString?: string;
}

export const useAllSPLTokenAmount = () => {
  const { walletAddress, isConnected, chain } = useBoomWallet();
  const { chainCoinBalance } = useAppStore();
  const [userTokenList, setUserTokenList] = useState<ITokenAmount[]>([]);

  const getUserTokenAmount = async () => {
    try {
      if (isConnected && walletAddress && chain == 'solana') {
        const tokenList = await getAllAssociatedTokens(walletAddress);
        const hasBalanceTokenList = tokenList.filter((item) => item.uiAmount !== 0);
        setUserTokenList(hasBalanceTokenList);
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    getUserTokenAmount();
  }, [isConnected, walletAddress, chainCoinBalance]);

  return {
    userTokenList,
    getUserTokenAmount,
  };
};
